export const navigationRoutes = {
  root: {

    displayName: 'navigationRoutes.home',
  },
  routes: [
    {

      path: '/',
      displayName: 'Dashboard',
      meta: {
        iconClass: 'vuestic-iconset-dashboard',
      },
    },
    {
      path: 'offenders',
      displayName: 'Offenders',
      meta: {
        iconClass: 'vuestic-iconset-user',
      },
      disabled: true,
      children: [
        {
          path: '/offenders',
          displayName: 'Accused/Offenders',
        },
      ],
    },
    {
      path: 'UserDetails',
      displayName: 'User Details',
      meta: {
        iconClass: 'vuestic-iconset-user',
      },
      disabled: true,
      children: [
        {
          path: '/users/active',
          displayName: 'Active Users',
        },
        {
          path: '/users/pending',
          displayName: 'Pending Users',
        },
        {
          path: '/users/reject',
          displayName: 'Rejected Users',
        },
        // {
        //   path: '/usermap',
        //   displayName: 'User Locations',
        // },
      ],
    },
    {
      path: 'analysts',
      displayName: 'Analysts',
      meta: {
        iconClass: 'vuestic-iconset-user',
      },
      disabled: true,
      children: [
        {
          path: '/analysts',
          displayName: 'Analysts',
        },
      ],
    },
    {
      path: 'crimeReports',
      displayName: 'Crime Reports',
      meta: {
        iconClass: 'vuestic-iconset-forms',
      },
      disabled: true,
      children: [

        {
          path: '/reportslist/noData',
          displayName: 'Report List',
        },
        // {
        //   path: 'reportsview',
        //   displayName: 'menu.reportsview',
        // },
      ],
    },
    {
      path: 'elements',
      displayName: 'Elements',
      meta: {
        iconClass: 'vuestic-iconset-extras',
      },
      disabled: true,
      children: [
        {
          path: '/crimetypes',
          displayName: 'Crime Types',
        },
        {
          path: '/settingAvatars',
          displayName: 'Avatars',
        },
        {
          path: '/usertype',
          displayName: 'User Types',
        },
        {
          path: '/sources',
          displayName: 'Sources',
        },
        {
          path: 'classification',
          displayName: 'Classification',
        },
        {
          path: '/wlpa',
          displayName: 'WLPA',
        },
        {
          path: '/cites',
          displayName: 'CITES',
        },
      ],
    },

    {
      path: 'analytics',
      displayName: 'Analytics',
      meta: {
        iconClass: 'vuestic-iconset-graph',
      },
      disabled: true,
      children: [
        {
          path: '/Crimereportanalytics',
          displayName: 'Crime Report Analytics',
        },
      ],
    },
    {
      path: 'digitalGuide',
      displayName: 'Digital Guide',
      meta: {
        iconClass: 'vuestic-iconset-files',
      },

      children: [
        {
          path: '/addRecords',
          displayName: 'Add Records',
        },
        {
          path: '/listRecords',
          displayName: 'View Records',
        },

      ],
    },

    {
      path: 'guideList',
      displayName: 'Identification Guide',
      meta: {
        iconClass: 'vuestic-iconset-comments',
      },

      children: [
        {
          path: '/guideList',
          displayName: 'Guide List',
        },

      ],
    },
    {
      path: 'queries',
      displayName: 'Replying Queries',
      meta: {
        iconClass: 'vuestic-iconset-comments',
      },

      children: [
        {
          path: '/listqueries',
          displayName: 'Queries List',
        },

      ],
    },
    {
      path: 'customenquiry',
      displayName: 'Custom Official Enquiries',
      meta: {
        iconClass: 'vuestic-iconset-comments',
      },

      children: [
        {
          path: '/enquirylist',
          displayName: 'Enquiries List',
        },

      ],
    },

    {
      path: 'ExcelReports',
      displayName: 'Excel Reports',
      meta: {
        iconClass: 'vuestic-iconset-forms',
      },

      children: [
        {
          path: '/speciesSchedule',
          displayName: 'Species Schedules',
        },

      ],
    },

  ],
  analystRoutes: [
    {

      path: '/',
      displayName: 'Dashboard',
      meta: {
        iconClass: 'vuestic-iconset-dashboard',
      },
    },
    {
      path: 'offenders',
      displayName: 'Offenders',
      meta: {
        iconClass: 'vuestic-iconset-user',
      },
      disabled: true,
      children: [
        {
          path: '/offenders',
          displayName: 'Accused/Offenders',
        },
      ],
    },
    {
      path: 'crimeReports',
      displayName: 'Crime Reports',
      meta: {
        iconClass: 'vuestic-iconset-forms',
      },
      disabled: true,
      children: [
        {
          path: '/reportslist/noData',
          displayName: 'Assigned Reports',
        },
        {
          path: '/allreportslist/noData',
          displayName: 'All Reports',
        },
      ],
    },
    {
      path: 'digitalGuide',
      displayName: 'Digital Guide',
      meta: {
        iconClass: 'vuestic-iconset-files',
      },

      children: [
        {
          path: '/addRecords',
          displayName: 'Add Records',
        },
        {
          path: '/listRecords',
          displayName: 'View Records',
        },

      ],
    },

  ],
}
